<div class="corrections" *ngIf="correctionFor || corrections?.length">

  <div class="correction-banner" *ngIf="correctionFor" (click)="open.emit(correctionFor._id)">
    <div class="banner-title">Correction Transaction</div>
    <div class="banner-text">
      This transaction is a correction applied to
      <span class="banner-target">{{correctionFor.name || correctionFor.accountName || 'a transaction'}}</span>
      ({{isMoney ? display(correctionFor.amount) : (correctionFor.amount ?? '—')}} &middot; {{correctionFor.time | rf:'dateTime'}}).
    </div>
    <div class="banner-link">View corrected transaction &rsaquo;</div>
  </div>

  <ng-container *ngIf="corrections?.length">
    <div class="section-label">Corrections</div>
    <div class="correction-card clickable" *ngFor="let c of corrections" (click)="open.emit(c._id)">
      <div class="line">
        <span class="delta">{{display(c.amount)}}</span>
        <span class="meta">{{c.userName}} &middot; {{c.time | rf:'dateTime'}}</span>
      </div>
      <div class="note" *ngIf="c.note">{{c.note}}</div>
    </div>
  </ng-container>

</div>
